export default __webpack_public_path__ + "static/media/Community-Hands-1.113a8638.svg";